import { render, staticRenderFns } from "./FullTextPage.vue?vue&type=template&id=5cf7dbf1&scoped=true&"
import script from "./FullTextPage.vue?vue&type=script&lang=js&"
export * from "./FullTextPage.vue?vue&type=script&lang=js&"
import style0 from "./FullTextPage.vue?vue&type=style&index=0&id=5cf7dbf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf7dbf1",
  null
  
)

export default component.exports